// src/admin/pages/KPI/components/kpi/ProcessoSection.jsx
import React from "react";
import { useMediaQuery } from "react-responsive";
import KPICard from "./KPICard";

const toHHMMSS = (sec = 0) => {
  let t = Math.floor(sec);
  const hh = String(Math.floor(t / 3600)).padStart(2, "0");
  t %= 3600;
  const mm = String(Math.floor(t / 60)).padStart(2, "0");
  const ss = String(t % 60).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
};

export default function ProcessoSection({ kpis, onCardClick, area = "all", onAreaChange }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (!kpis) return null;

  return (
    <>
      {/* filtro area */}
      <div style={styles.areaBar}>
        {[
          { key: "all",     label: "Tutti"   },
          { key: "kitchen", label: "Cucina"  },
          { key: "bar",     label: "Bar"     },
        ].map(opt => (
          <button
            key={opt.key}
            onClick={() => (opt.key !== area) && onAreaChange?.(opt.key)}
            style={{
              ...styles.areaBtn,
              ...(area === opt.key ? styles.areaBtnActive : {}),
            }}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* KPI card */}
      <div style={grid(isMobile)}>
        <KPICard
          title="Durata Media Sessione"
          value={toHHMMSS(kpis.avg_session_duration)}
          description="(HH:MM:SS)"
          onClick={() => onCardClick?.("avg_session_duration")}
        />
        <KPICard
          title="Tempo Medio Prep."
          value={toHHMMSS(kpis.avg_prep_time)}
          description="(HH:MM:SS)"
          onClick={() => onCardClick?.("avg_prep_time")}
        />
        <KPICard
          title="Tempo Medio Consegna"
          value={toHHMMSS(kpis.avg_order_delivery_time)}
          description="Ready → Delivered"
          onClick={() => onCardClick?.("avg_order_delivery_time")}
        />
        <KPICard
          title="Tempo Medio in Coda"
          value={toHHMMSS(kpis.avg_queue_time)}
          description="Attesa prima di iniziare"
          onClick={() => onCardClick?.("avg_queue_time")}
        />
        <KPICard
          title="Tempo Medio Totale"
          value={toHHMMSS(kpis.avg_total_time)}
          description="Invio cucina → consegna"
          onClick={() => onCardClick?.("avg_total_time")}
        />
      </div>
    </>
  );
}

/* ---------- layout ---------- */
const grid = isMobile => ({
  display: "grid",
  gap: "1rem",
  marginTop: "1rem",
  gridTemplateColumns: isMobile
    ? "repeat(auto-fill, minmax(160px, 1fr))"
    : "repeat(auto-fill, minmax(200px, 1fr))",
});

/* ---------- styles ---------- */
const styles = {
  areaBar: {
    display: "inline-flex",
    borderRadius: 8,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
    margin: "1rem 0",            // ↑ spazio sopra e sotto il filtro
  },
  areaBtn: {
    flex: "1 1 0",
    padding: ".45rem .9rem",
    border: "none",
    background: "#F5F5F5",
    color: "#333",
    fontWeight: 600,
    cursor: "pointer",
    transition: "background .15s, color .15s",
  },
  areaBtnActive: {
    background: "#336699",
    color: "#FFF",
  },
};
